import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10.5,
	height: 12,
	viewBox: "0 0 10.5 12",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M10.5,11.19a.81.81,0,0,1-.81.81H.81A.81.81,0,0,1,0,11.19,4.07,4.07,0,0,1,4.06,7.12H6.44A4.07,4.07,0,0,1,10.5,11.19ZM2.25,3a3,3,0,1,1,3,3A3,3,0,0,1,2.25,3Z" })]
});
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
